import { Helmet } from "react-helmet-async";

/**
 * Per-page SEO helper. Injects title, meta description, canonical, og and
 * twitter tags. All variants of the artist name are included so search
 * queries for "Alex Soto", "Alekz Soto", "Alexander Soto" or "ALEKZ" all
 * surface the site.
 */
export default function SEO({ title, description, path = "/", image }) {
  const base = "https://alekzsoto.com";
  const fullUrl = `${base}${path}`;
  const finalTitle = title ? `${title} — ALEKZ | Alex Soto` : "ALEKZ — Alex Soto | DJ & Techno Producer, New York";
  const finalDesc =
    description ||
    "ALEKZ is the artist project of Alex Soto (Alekz Soto / Alexander Soto), a New York-based DJ, techno producer and creative.";
  const finalImage = image || `${base}/alekz-portrait.jpg`;

  return (
    <Helmet>
      <title>{finalTitle}</title>
      <meta name="description" content={finalDesc} />
      <link rel="canonical" href={fullUrl} />

      <meta property="og:title" content={finalTitle} />
      <meta property="og:description" content={finalDesc} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:image" content={finalImage} />

      <meta name="twitter:title" content={finalTitle} />
      <meta name="twitter:description" content={finalDesc} />
      <meta name="twitter:image" content={finalImage} />
    </Helmet>
  );
}
